module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetMedium.964b792.webp";